export function handleChange (e, data)
{
	const component = this, props = this.props, state = this.state;

	var form_data       = this.state.form_data;
	var status_messages = Object.assign({ }, this.state.status_messages);

	status_messages[data.name] = status_messages[data.name] || { };

	status_messages[data.name].error   = undefined;
	status_messages[data.name].info    = undefined;
	status_messages[data.name].warning = undefined;

	let name = '';

	if (!e && props.config)
	{
		data.name.split('[').join(']').split(']')
		.filter((str, i) => str !== '' && i > 0)
		.forEach(function (prop, index)
		{
			if (index === 0)
			{
				name += prop;
			}
			else
			{
				name += '[' + prop + ']';
			}
		});

		let field_config = props.config.fields[name];

		if (field_config && field_config.type === 'password')
		{
			return;
		}
	}

	if (data.display_name)
	{
		if (typeof data.data !== 'undefined' && data.data.id)
		{
			form_data[data.name] = data.data.id;
			form_data[data.display_name] = data.value;
		}
		else
		{
			form_data[data.name] = '';
			form_data[data.display_name] = data.value;
		}
	}
	else
	{
		if (form_data[data.name] === data.value)
		{
			return;
		}

		form_data[data.name] = data.value;
	}

	component.setState(
	{
		status_messages: status_messages,
		collapses_status: { },
		form_data: form_data,
		error: undefined,
		warning: undefined,
		info: undefined,
		created: e && data.type !== 'editor' ? undefined : state.created
	});
}